import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../../common/helpers/WithAjax'
import { setClientRequestSearchDropdownOptions, 
  validateClientRequestSearchField,
  clearClientRequestSearchFields } from '../../../actions/pages/clientaccount-page'
import SingleLineSearchForm from '../../common/form/SingleLineSearchForm'
import Select from '../../common/form/Select'

class ClientRequestSearch extends Component {

  componentWillUnmount() {
    this.props.clearClientRequestSearchFields();
  }

  componentDidMount() {
    let url = 'clientaccounts/productionContentOwners';
    this.props.ajax.get(url, true, (data) => {
      this.props.setClientRequestSearchDropdownOptions(data);
    });
  }

  render() {
    let fields = this.props.fields;

    return (
      <SingleLineSearchForm fields={fields} onSearch={this.props.onSearch}>
          <div className="col-2">
            <Select field={fields[0]} validate={this.props.validateClientRequestSearchField} />
          </div>
      </SingleLineSearchForm>
    )
  }
}

const mapStateToProps = (state) => ({
	fields: state.clientRequestSearch.fields
})
const mapDispatchToProps = dispatch => ({
  clearClientRequestSearchFields() { dispatch(clearClientRequestSearchFields()) },
  setClientRequestSearchDropdownOptions(productionContentOwners) { dispatch(setClientRequestSearchDropdownOptions(productionContentOwners)) },
	validateClientRequestSearchField(value, field) { dispatch(validateClientRequestSearchField(value, field)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(ClientRequestSearch))